import PersPackageTypes from 'store/actionTypes/persPackage'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {}
}

const persPackage = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case PersPackageTypes.GET_PERS_PACKAGES_SUCCESS:
      return {
        ...state,
        list: payload?.persPackage?.items,
        pagination: payload?.persPackage?.meta
      }
    case PersPackageTypes.GET_PERS_PACKAGE_BY_ID_SUCCESS:
      return { ...state, current: payload }
    case PersPackageTypes.UPDATE_FILTER_PERS_PACKAGE_SUCCESS:
      return { ...state, filter: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default persPackage
